/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {SectionDemo, SectionDemoSpacing, SectionDemoWhite, SectionDemoDivider, SectionDemoMintGreen, SectionDemoSeaGreen, SectionDemoEmeraldGreen, SectionDemoLavender, SectionDemoBlack3, SectionDemoSandYellow, SectionDemoPistachio, SectionDemoFireRed, SectionDemoFireRed8, SectionZIndex} from 'Docs/uilib/components/section/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    h3: "h3"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Demos"
    }), "\n", _jsx(_components.h3, {
      children: "Default Section without spacing"
    }), "\n", _jsx(SectionDemo, {}), "\n", _jsx(_components.h3, {
      children: "Default Section with large spacing"
    }), "\n", _jsx(SectionDemoSpacing, {}), "\n", _jsx(_components.h3, {
      children: "White Section"
    }), "\n", _jsx(SectionDemoWhite, {}), "\n", _jsx(_components.h3, {
      children: "Divider Section"
    }), "\n", _jsx(SectionDemoDivider, {}), "\n", _jsx(_components.h3, {
      children: "Mint-Green Section"
    }), "\n", _jsx(SectionDemoMintGreen, {}), "\n", _jsx(_components.h3, {
      children: "Sea-Green Section"
    }), "\n", _jsx(SectionDemoSeaGreen, {}), "\n", _jsx(_components.h3, {
      children: "Emerald-Green Section"
    }), "\n", _jsx(SectionDemoEmeraldGreen, {}), "\n", _jsx(_components.h3, {
      children: "Lavender Section"
    }), "\n", _jsx(SectionDemoLavender, {}), "\n", _jsx(_components.h3, {
      children: "Grey Section"
    }), "\n", _jsx(SectionDemoBlack3, {}), "\n", _jsx(_components.h3, {
      children: "Sand-Yellow Section"
    }), "\n", _jsx(SectionDemoSandYellow, {}), "\n", _jsx(_components.h3, {
      children: "Pistachio Section"
    }), "\n", _jsx(SectionDemoPistachio, {}), "\n", _jsx(_components.h3, {
      children: "Fire-Red Section"
    }), "\n", _jsx(SectionDemoFireRed, {}), "\n", _jsx(_components.h3, {
      children: "Fire-Red-8 Section"
    }), "\n", _jsx(SectionDemoFireRed8, {}), "\n", _jsx(SectionZIndex, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
